// extracted by mini-css-extract-plugin
export default {"container":"Skeleton__container--lc-SYmlx","title":"Skeleton__title--lc-KhrMx","grid":"Skeleton__grid--lc-Dq_WE"};